// extracted by mini-css-extract-plugin
export default {"container":"style_container__7F1CH","text":"style_text__99xPY","h1":"style_h1__eoVo2","astronaut_img":"style_astronaut_img__7OnaS","astronautFly":"style_astronautFly__30uf0"};